import React from 'react'; 
 
import axios from 'axios'; 
import {base_url} from '../common/Constants';
import { Link } from 'react-router-dom'; 
 

 
class CareersContent extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            careers : this.props.careers,
            loading : 0
        }
    }
 
    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div class="container">
        <div class="row careers-wrap">
            <div class="col-md-12 ">
            <div className={ this.props.careers.length === 0 ? "dblock" : "dnone" }>No Openings Found</div>
             
                {this.props.careers.map((career,key)=>{
 
                    return <div className="col-md-12 col-lg-12">
                    <div className="blog-card wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='000ms'>
                        <div className="blog-card__content">
                            <div className="blog-card__top">
                                <div className='career-title'>
                                    <div className="blog-card__date"><span>{career.created_date}</span> <span>{career.created_month}</span></div> 
                                    <h3 className="blog-card__title">{career.title}</h3>
                                </div>
                                <div className='career-info'>
                                    <ul className="list-unstyled blog-card__meta">
                                    <li> <b>Position: </b>{career.position}</li> 
                                    <li> <b>Skills: </b>{career.skills}</li> 
                                    </ul> 
                                    <div className="blog-card__description"><p>{career.description}</p></div> 
                                    <div className="blog-card__description">
                                        <Link to={base_url+`apply-now/${career.slug}`} class="btn btn-primary apply">Apply Now </Link> </div> 
                                </div>
                                
                            </div> 
                             
                        </div> 
                    </div> 
                </div>  
                 })}
   

                
   </div>
   </div>
         </div>   
    );
}

}

export default CareersContent;